module.exports = __webpack_public_path__ + "img/6.4ebba8f4.jpg";